/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import { actionTypes } from '../actions/common';

const initialState = 0;

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ERROR:
    case actionTypes.ACTION_COMPLETED: {
      return Math.max(state - 1, 0);
    }
    case actionTypes.ACTION_STARTED: {
      return state + 1;
    }
    default: {
      return state;
    }
  }
}
